// extracted by mini-css-extract-plugin
export default {"list":"PlaceSearch_list__jU9IP","anchorNote":"PlaceSearch_anchorNote__onVJQ","mapScreen":"PlaceSearch_mapScreen__O4bx6"};